/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgComponentsGroup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 20h2v2h-2zM2 2h2v2H2zm0 9h2v2H2zm0-5h2v2H2zm9-4h2v2h-2zM6 2h2v2H6zM2 20h2v2H2zm0-4h2v2H2zm4 4h2v2H6zM20 6h2v2h-2zm0 5h2v2h-2zm0-9h2v2h-2zm0 14h2v2h-2zm-4 4h2v2h-2zm0-12h-6V6H8v2H6v2h2v6h6v2h2v-2h2v-2h-2zm-2 6h-4v-4h4zm2-12h2v2h-2zm4 18h2v2h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgComponentsGroup as ComponentsGroup };
